'use client';

import { twMerge } from 'tailwind-merge';
import { Document } from '@contentful/rich-text-types';

import { CollapsibleText } from '../../../../components/CollapsibleText/CollapsibleText';
import { Heading } from '../../../../components/Heading/Heading';
import { RichText } from '../../../../components/RichText/RichText';
import { Text } from '../../../../components/Text/Text';
import { ExternalLink } from '../../../../components/Clickables/ExternalLink/ExternalLink';
import { ArrowUpRightIcon } from '../../../../components/Icons/ArrowUpRightIcon';
import { SUB_LINK_IDS } from '../../helpers/regionHelpers';

interface IProps {
  regionName: string;
  licenseInfoUrl?: string;
  className?: string;
  generalInfoText: string;
  fishingLicenseInfoRichText?: Document;
}

export const GeneralInfoSection = ({
  regionName,
  licenseInfoUrl,
  className,
  generalInfoText,
  fishingLicenseInfoRichText,
}: IProps) => {
  return (
    <div
      id={SUB_LINK_IDS.GENERAL_INFO}
      className={twMerge(
        'w-full scroll-mt-(--navigation-scrolltop-offset-mobile) sm:scroll-mt-(--navigation-scrolltop-offset)',
        className,
      )}
    >
      <div className="bg-lake-fog flex size-full flex-col justify-center gap-8 px-6 py-10 sm:px-11 sm:py-12 md:rounded-xl md:px-8 md:py-8">
        <div className="flex flex-col gap-2">
          <Heading variant="sm" as="h3">
            {`About ${regionName} fishing`}
          </Heading>
          <Text variant="md" className="m-0">
            {generalInfoText}
          </Text>
        </div>
        {licenseInfoUrl && (
          <div className="flex flex-col gap-2">
            <Heading variant="sm" as="h3">
              {`${regionName} fishing license`}
            </Heading>
            {fishingLicenseInfoRichText && (
              <CollapsibleText maxLines={3} clampOn={['tablet', 'desktop']}>
                <RichText
                  document={fishingLicenseInfoRichText}
                  className="prose prose-fishbrain prose-p:mt-2"
                />
              </CollapsibleText>
            )}
            <ExternalLink
              href={licenseInfoUrl}
              className="heading-text-xxs constantSize font-heading text-trench flex items-center font-medium!"
              target="_blank"
              variant="textNone"
            >
              Get license <ArrowUpRightIcon />
            </ExternalLink>
          </div>
        )}
      </div>
    </div>
  );
};
